import { render, staticRenderFns } from "./ViewerProductList.vue?vue&type=template&id=4c3a73a0&"
import script from "./ViewerProductList.vue?vue&type=script&lang=js&"
export * from "./ViewerProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports